import { FC, useState } from "react";
import { NotificationTwoTone } from "@ant-design/icons";
import { ProButton } from '../../../antd';
import { VOICE_KEY } from '../../../constants/localStorage';

interface VoiceProps {};

const Voice: FC<VoiceProps> = () => {
  const [voice, isVoice] = useState<boolean>(window.localStorage.getItem(VOICE_KEY) !== 'close');
  const handleClick = () => {
    isVoice(prev => {
      const newVoice = !prev;
      window.localStorage.setItem(VOICE_KEY, newVoice ? 'open' : 'close');
      return newVoice;
    });
  };
  return (
    <ProButton icon={<NotificationTwoTone />} onClick={handleClick}>{voice ? '已开启语音' : '已关闭语音'}</ProButton>
  );
};

export default Voice;
